<div *ngIf="!loader">
  <div class="heading_sert">
      <sm-title-bar pageTitle="Configure online payment" [back]="true"></sm-title-bar>
   </div>
      
   <div class="row">
      <div class="col-sm-8">
  
          <div class="lsk_cardf">
      <div>
          <mat-form-field appearance="outline">
            <mat-label >Email</mat-label>
            <input matInput [(ngModel)]="onlinePaymentsObj.email " required/>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label >Phone number (range 8-15)</mat-label>
            <input matInput type="tel" [minLength]="8" [maxLength]="15" [(ngModel)]="onlinePaymentsObj.phone" required/>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label >Bank name</mat-label>
            <input matInput [(ngModel)]="onlinePaymentsObj.bank_name" required/>
          </mat-form-field>
        </div>
      
        <div>

          <mat-form-field appearance="outline" >
            <mat-label>Business type</mat-label>
            <mat-select required [(value)]="selectedBusinessType">
              
              <mat-option
              *ngFor="let item of businessType"
              [value]="item"
              
              >
              {{ item | uppercase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
        <div>

          <mat-form-field appearance="outline">
            <mat-label>Business category</mat-label>
            <mat-select required [(value)]="selectedCategory"
            (selectionChange)="onCategorySelected($event)">
              
              <mat-option
              *ngFor="let item of businessCategories"
              [value]="item"
              
              >
              {{ item.category | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
        <div>

          <mat-form-field appearance="outline">
            <mat-label>Business sub-category</mat-label>
            <mat-select required [(value)]="selectedSubCategory">
              
              <mat-option
              *ngFor="let item of selectedCategory?.subcategories"
              [value]="item"
              
              >
              {{ item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div >
          <mat-form-field appearance="outline">
            <mat-label >Account holder name</mat-label>
            <input matInput [(ngModel)]="onlinePaymentsObj.account_holder_name "/>
          </mat-form-field>
        </div>
      <div >
          <mat-form-field appearance="outline">
            <mat-label >Branch name</mat-label>
            <input matInput matInput [(ngModel)]="onlinePaymentsObj.branch_name"/>
          </mat-form-field>
        </div>
      <div class="radio_group accountradio">
          <label class="reftty">Account type: </label> <br>
          <mat-radio-group [(ngModel)]="onlinePaymentsObj.accountType">
            <mat-radio-button [value]="0">Savings</mat-radio-button>
            <mat-radio-button [value]="1">Current</mat-radio-button>
          </mat-radio-group>
        </div>
       
        <div >
          <mat-form-field appearance="outline">
            <mat-label>Account number</mat-label>
            <input [(ngModel)]="onlinePaymentsObj.account_number " matInput/>
          </mat-form-field>
        </div>
        <div >
          <mat-form-field appearance="outline">
            <mat-label>IFSC code</mat-label>
            <input matInput [(ngModel)]="onlinePaymentsObj.ifsc_code "/>
          </mat-form-field>
        </div>
        <div >
          <mat-form-field appearance="outline">
            <mat-label>PAN card number</mat-label>
            <input matInput [(ngModel)]="onlinePaymentsObj.pan_card_number " />
          </mat-form-field>
        </div>
        <div >
          <mat-form-field appearance="outline">
            <mat-label>GST number</mat-label>
            <input matInput [(ngModel)]="onlinePaymentsObj.gst_number "/>
          </mat-form-field>
        </div>
        <div class="radio_group">
          <label class="reftty">Refund period: </label> <br>
          <mat-radio-group [(ngModel)]="onlinePaymentsObj.refund_period">
            <mat-radio-button [value]="5">5 days</mat-radio-button>
            <mat-radio-button [value]="10">10 days</mat-radio-button>
            <mat-radio-button [value]="15">15 days</mat-radio-button>
          </mat-radio-group>
        </div>
  
        <div class="cabh_sect">
          <!-- <button  mat-flat-button color="accent" class="resat-btn" >Cancel</button> -->
        <button mat-flat-button color="accent" class="submit-btn" (click)="onSubmitOnlinePaymentsDetails()"
        [disabled]="
        !onlinePaymentsObj.email ||
        !onlinePaymentsObj.phone ||
        !onlinePaymentsObj.bank_name ||
        !selectedBusinessType ||
        !selectedCategory ||
        !selectedSubCategory ||
        !onlinePaymentsObj.account_holder_name ||
        !onlinePaymentsObj.branch_name ||
        !onlinePaymentsObj.account_number ||
        !onlinePaymentsObj.ifsc_code ||
        !onlinePaymentsObj.gst_number ||
        !onlinePaymentsObj.pan_card_number  
        ">Save</button>
        </div>
      </div>
      </div>
  
  
      <div class="col-md-4 booking-sidebar">
        <div class="faq">
           <mat-accordion>
              <mat-expansion-panel [expanded]="panelState[0]" (opened)="panelState[0] = true" (closed)="panelState[0] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                    Is online payment and adding a bank account is compulsory for all?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>No. It's optional. You can enable online payment and add a bank account only if you are collecting customer payment via LookzUp platform. If you enable this, your customer can be able to pay you via LookzUp app or website. 
              </p>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelState[1] = true"
              (closed)="panelState[1] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                    Which bank account should I add?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>This is up to you. Preferably the account which is associated with the business. But you can add other account too. Your customer payment will be credited to that account via LookzUp. 
              </p>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelState[2] = true"
              (closed)="panelState[2] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                    Should there be any deduction in the transaction?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>A certain percentage (~2.1%) of the transacted amount can be deducted as the platform fee.  
              </p>
              </mat-expansion-panel>

              <mat-expansion-panel (opened)="panelState[3] = true"
              (closed)="panelState[3] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                    What is the refund period?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>This is the period you can set on which a customer can ask for a refund.  
              </p>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelState[4] = true"
              (closed)="panelState[4] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                    Where I can see the online payment data?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>In the 'Online payments' segment of the 'Reports' section, you can see detail data on it.
              </p>
              </mat-expansion-panel>
           
           </mat-accordion>
        </div>
     </div>
  
      </div>

</div>